import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatDateString } from "./fulfillment-group-csv-utils";

export const MarketplaceFulfillByCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Marketplace fulfill by",
    cell: (row) => formatDateString(row.fulfillBy?.toISOString()),
  };
